import React from 'react';
import { IntegrationProps } from '../types';

export const GenericPlatformSettings: React.FC<IntegrationProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4 animate-in fade-in">
      <div className="p-3 bg-slate-50 text-slate-600 text-xs rounded-lg">
        Custom integration parameters for other platforms.
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">API Endpoint</label>
        <input
          type="text"
          value={config.apiUrl || ''}
          onChange={(e) => onChange({ apiUrl: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">API Key</label>
        <input
          type="password"
          value={config.apiKey || ''}
          onChange={(e) => onChange({ apiKey: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
    </div>
  );
};